// extracted by mini-css-extract-plugin
export default {"error404":"Error404_error404__QVMk3","wrapper":"Error404_wrapper__LSyXs"};